import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'minio',
    standalone: false
})
export class MinioUrlPipe implements PipeTransform {
    transform(path: string): string {
        return `https://objectdelivery.etrace-eagro.com${path}`;
    }
}
